module.exports = __webpack_public_path__ + "img/package.ff92a04.png";